import React, {Component} from 'react';
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import API from "../../services/API";
import {toast} from "react-toastify";
import {
    faMapMarkerAlt,
    faWindowClose,
    faPlus,
    faCheck,
    faArrowAltCircleUp,

    faTruckLoading,
    faCloudDownloadAlt,
    faCubes,
    faServer,

} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import moment from "moment-jalaali";

import 'react-times/css/material/default.css';

const currencyFormat = Intl.NumberFormat('en-US');

class NewSmallCargoRequest extends Component {
    state = {
        addresses : [],
        loading_addresses : window.localStorage.getItem("loading_addresses") ?
            JSON.parse("[" + window.localStorage.getItem("loading_addresses") + "]") : [],
        unloading_addresses : window.localStorage.getItem("unloading_addresses") ?
            JSON.parse("[" + window.localStorage.getItem("unloading_addresses") + "]") : [],

        loading_date : '',
        loading_time : '00:00',
        loading_do_from : '',
        loading_do_to : '00:00',
        time_message : 'محموله آماده بارگیری است',
        unloading_date : '',
        unloading_time :  '00:00',
        unloading_do_from : '00:00',
        unloading_do_to : '00:00',
        load_value : 50000000,
        description : '',
        load_width1 : '',
        load_width2 : '',
        load_length1 : '',
        load_length2 : '',
        load_height1 : '',
        load_height2 : '',

        load_tonnage1 : '',
        load_tonnage2 : '',
        pack_count : '',
        pay_type_check : 0,
        need_expert : 0,
        need_delivery_documents : 0,
        consignments : window.localStorage.getItem("consignment") ? JSON.parse(window.localStorage.getItem("consignment")) : [],
        consignments_list : [],
        show_consignments_box : false,
        package_types : [],
        pack_type : 0,
        ctitle : '',
        cdescription : '',
        parent_car_types: [],
        car_types: [],
        car_type_id: 0,
        parent_car_type_id: 0,
        suggested_price : '',
        is_personal : 0,
        user_is_verified : 1,
        company_is_verified : 1,
        document_file: null,
        document_description: '',
        document_title: '',
        show_do_loading: 0,
        show_do_unloading: 0,
        buttonStatus: "",
        buttonText : "ثبت درخواست",
        loading: "d-none",
        consignment_pack : []

    }

    onSaveRequest = () => {

        if(!this.state.loading_addresses.length) {
            toast.error(' حداقل یک آدرس برای بارگیری انتخاب کنید')
            return false;
        }

        if(!this.state.unloading_addresses.length) {
            toast.error(' حداقل یک آدرس برای تخلیه انتخاب کنید')
            return false;
        }


        if(Object.keys(this.state.consignments).length < 1){
            toast.error('لطفا نوع محموله بار را مشخص کنید')
            return false;
        }

/*        if((!this.state.load_width1 || !this.state.load_width2) && (!this.state.load_length1 || !this.state.load_length2) ) {
            toast.error('ابعاد و وزن بار خود را وارد کنید')
            return false;
        }*/


        if(Object.keys(this.state.consignment_pack).length < Object.keys(this.state.consignments).length) {
            toast.error('لطفا برای همه محموله ها نوع بسته بندی را انتخاب کنید')
            return false;
        }
        const load_width = this.state.load_width1 * 100 + +this.state.load_width2;
        const load_height = this.state.load_height1 * 100 + +this.state.load_height2;
        const load_length = this.state.load_length1 * 100 + +this.state.load_length2;
        const load_tonnage = this.state.load_tonnage1 * 1000 + +this.state.load_tonnage2;
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });

        const request = {
            loading_addresses : this.state.loading_addresses,
            unloading_addresses : this.state.unloading_addresses,

            car_type_id: this.state.car_type_id,
            description: this.state.description,
            pack_count: this.state.pack_count,
            pay_type: this.state.pay_type_check,
            need_expert: this.state.need_expert,
            need_delivery_documents: this.state.need_delivery_documents,
            suggested_price: this.state.suggested_price,
            load_value: this.state.load_value,
            load_width : load_width,
            load_height : load_height,
            load_length : load_length,
            load_tonnage : load_tonnage,
            is_personal : this.state.is_personal,
            consignments : this.state.consignment_pack,
            car_message : null,
            small_cargo : 1
        }
        window.localStorage.setItem("consignment" ,JSON.stringify(this.state.consignments) );
        API.storeRequest(request)
            .then((response) => {
                toast.success(response.user_message);
                const requestID = response.results.request.id;
                const file = this.state.document_file;
                if (file) {
                    this.onUploadFile(requestID)
                }
                window.localStorage.removeItem("loading_addresses");
                window.localStorage.removeItem("unloading_addresses");

                setTimeout (() => {
                    this.props.history.push(`/request-profile/${requestID}`);

                },1500)
            })
            .catch((error) => {
                const buttonText  = "ثبت درخواست";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
                toast.error(error.response.data.user_message);
            });
    }
    onLoadingAddressChange = (event) => {


        if(this.state.unloading_addresses.filter(el => el === parseInt(event.target.value)).length > 0) {
            toast.error('این آدرس قبلا به عنوان آدرس تخلیه ثبت شده است');
            return false;
        }
        let  loading_addresses = [...this.state.loading_addresses , parseInt(event.target.value)];
        loading_addresses = loading_addresses.filter((v, i, a) => a.indexOf(v) === i);
        this.setState({loading_addresses})


    }
    showLoadingAddress = (addr) => {
        for (const element of this.state.addresses) {
            if(element.id === addr) {
                return <span>
                    {element.title}
                    &nbsp;
                    به آدرس
                    &nbsp;
                    <b>
                        {element.address}
                    </b>
                </span>
            }

        }
        return false
    }
    removeLoadingAddress = (addr) => {
        let array = this.state.loading_addresses;
        const index = array.indexOf(addr);
        if (index > -1) {
            array.splice(index, 1);
        }
        this.setState({loading_addresses : array})
    }
    onUnloadingAddressChange = (event) => {
        if(this.state.loading_addresses.filter(el => el === parseInt(event.target.value)).length > 0) {
            toast.error('این آدرس قبلا به عنوان آدرس بارگیری ثبت شده است');
            return false;
        }
        let  unloading_addresses = [...this.state.unloading_addresses , parseInt(event.target.value)];
        unloading_addresses = unloading_addresses.filter((v, i, a) => a.indexOf(v) === i);
        this.setState({unloading_addresses})
//        document.getElementById("unloading-date-label").scrollIntoView();
    }
    showUnloadingAddress = (addr) => {
        for (const element of this.state.addresses) {
            if(element.id === addr) {
                return <span>
                    {element.title}
                    &nbsp;
                    به آدرس
                    &nbsp;
                    <b>
                        {element.address}
                    </b>
                </span>
            }

            /*if(addr === element.id) {
                return element.address
            }*/
        }
        return false
    }
    removeUnloadingAddress = (addr) => {
        let array = this.state.unloading_addresses;
        const index = array.indexOf(addr);
        if (index > -1) {
            array.splice(index, 1);
        }
        this.setState({unloading_addresses : array})
    }
    onConsignmentsListChange = (event) => {
        let  consignments = [...this.state.consignments , parseInt(event.target.value)];
        consignments = consignments.filter((v, i, a) => a.indexOf(v) === i);
        this.setState({consignments})
    }
    onPackTypeChange = (event , id)  =>{

        let consignment_pack = this.state.consignment_pack;
        if (consignment_pack) {
            const find_item = consignment_pack.find(x => x.cons === id);
            if (find_item) {
                const objIndex = consignment_pack.findIndex((obj => obj.cons === id));
                consignment_pack[objIndex].pack = parseInt(event.target.value);
            } else {
                consignment_pack.push({'cons': id, 'pack': parseInt(event.target.value)})
            }
        }
        if (!consignment_pack) { //Object.keys(this.state.markets).length < 1
            consignment_pack = [];
            consignment_pack.push({'cons': id, 'pack': parseInt(event.target.value)})
        }
        this.setState({consignment_pack});


    }
    showConsignmentsList = (cong) => {
        for (const element of this.state.consignments_list) {
            if(element.id === cong) {
                return <span>
                    <b>{element.title}</b>
                    &nbsp;

                    ({element.description})
                    &nbsp;
                    بسته بندی:
                    <select className="super-small w-25 " id="pack_type" name="pack_type"
                            aria-label="Floating label select"

                            onChange={(event) => {this.onPackTypeChange (event , element.id) }}>
                                    <option value={0}>
                                        انتخاب نوع بسته بندی محموله
                                    </option>
                        {this.state.package_types.map(pack => {
                            return (
                                <option value={pack.id} key={pack.id}>
                                    {pack.title} : {pack.description}
                                </option>
                            )
                        })}
                                </select>

                    {/* -
                     <span className='small text-secondary'>
                    &nbsp;
                    نوع بسته بندی:
                    &nbsp;

                        {element.pack_type.title}
                    </span>*/}

                </span>
            }

        }
        return false
    }
    removeConsignmentsList = (addr) => {

        let array = this.state.consignments;
        const index = array.indexOf(addr);
        if (index > -1) {
            array.splice(index, 1);
        }
        let consignment_pack = this.state.consignment_pack;
        const find_item = consignment_pack.find(x => x.cons === addr);
        if (find_item) {

            const objIndex = consignment_pack.findIndex((obj => obj.cons === addr));
            consignment_pack.splice(objIndex, 1)

            this.setState({consignment_pack})

        }
        this.setState({consignments : array})
    }
    addNewAddress = (type) => {
        window.localStorage.setItem("loading_addresses", this.state.loading_addresses);
        window.localStorage.setItem("unloading_addresses", this.state.unloading_addresses);
        window.localStorage.setItem("return_to", 'request');
        window.localStorage.setItem("a_type", type);
        this.props.history.push('/profile/address');
    }
    onInputChange = (event) => {

        const inputName = event.target.name;
        let inputValue = event.target.value;
        if(inputName === 'is_personal') {
            inputValue = 1 - this.state.is_personal
        }
        if(inputName === 'pay_type_check') {
            inputValue = 1 - this.state.pay_type_check
        }
        if(inputName === 'need_delivery_documents') {
            inputValue = 1 - this.state.need_delivery_documents
        }
        if(inputName === 'need_expert') {
            inputValue = 1 - this.state.need_expert
        }
        this.setState({[inputName]: inputValue});
    }
    onTimeChange = (event , type) => {
        const time = event.hour + ":" + event.minute;
        if(type === 'loading_time' ) {
            this.setState({unloading_time : '00:00'});
            const loading_date = this.state.loading_date.format("YYYY-MM-DD");
            const current_date = moment().format("YYYY-MM-DD");
            if(loading_date === current_date && event.hour < moment().format('HH')) {
                toast.error('زمان بارگیری نمی تواند قبل از ساعت جاری باشد!');
                return false;
            }
            if(loading_date === current_date && event.hour === moment().format('HH')) {
                this.setState({
                    time_message : ' محموله آماده بارگیری می باشد '
                })

            }
            else {
                this.setState({
                    time_message : ''
                })
            }

        }
        if(type === 'unloading_time' ) {
            if(!this.state.unloading_date ) {
                toast.error('ابتدا تاریخ تخلیه  را انتخاب کنید');
                return false;
            }
            const loading_date = this.state.loading_date.format("YYYY-MM-DD");
            const unloading_date = this.state.unloading_date.format("YYYY-MM-DD");

            if(loading_date === unloading_date && time <= this.state.loading_time) {
                toast.error('زمان تخلیه نمی تواند قبل از زمان بارگیری باشد');
                return false;
            }
        }
        if(type === 'loading_do_to' ) {
            if(time <= this.state.loading_time) {
                toast.error('زمان پایان بارگیری نمی تواند برابر و یا قبل تر از زمان شروع بارگیری باشد.');
                return false;
            }
        }
        if(type === 'unloading_do_to' ) {
            if(time <= this.state.unloading_time) {
                toast.error('زمان پایان تخلیه نمی تواند برابر و یا قبل تر از زمان شروع تخلیه باشد.');
                return false;
            }
        }
        this.setState({[type] : time});
        if(type === 'loading_time') {
            this.setState({loading_do_from : time});
            // document.getElementById("unloading-info").scrollIntoView();
        }
        if(type === 'unloading_time') {
            this.setState({unloading_do_from : time});
            //  document.getElementById("load-info").scrollIntoView();
        }



    }
    onSaveConsignment = () => {
        /*        if(this.state.pack_type === 0) {
                    toast.error('نوع بسته بندی را انتخاب کنید.');
                    return false;
                }*/
        const request = {
            title: this.state.ctitle,
            description: this.state.cdescription,
            //  pack_type_id: this.state.pack_type
        }
        API.consignmentsSave(request)
            .then((response) => {
                toast.success(response.user_message);
                let  consignments = [...this.state.consignments , parseInt(response.results.consignment.id)];
                consignments = consignments.filter((v, i, a) => a.indexOf(v) === i);
                this.setState({consignments})
                API.consignments()
                    .then((response) => {

                        const consignments_list = response.results.consignments;
                        this.setState({consignments_list})

                    })
                    .catch((error) => {
                        toast.error(error.response.data.user_message);
                    });
                this.setState({show_consignments_box : false})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onCarTypeChange = (event) => {
        const inputValue = parseInt(event.target.value);
        this.setState({parent_car_type_id: inputValue});
        const load_width = this.state.load_width1 * 100 + +this.state.load_width2;
        const load_height = this.state.load_height1 * 100 + +this.state.load_height2;
        const load_length = this.state.load_length1 * 100 + +this.state.load_length2;
        const load_tonnage = this.state.load_tonnage1 * 1000 + +this.state.load_tonnage2;
        if(event.target.value > 0) {
            const request = {
                parent_id: event.target.value,
                min_tonnage: load_tonnage,
                min_length: load_length,
                min_width: load_width,
                min_height: load_height
            }
            API.carTypes(request)
                .then((response) => {
                    const car_types = response.results.car_types;
                    this.setState({car_types})
                    if(Object.keys(car_types).length === 0) {
                        this.setState({car_message : 'خودرویی در این نوع خودرو متناسب با ابعادی که تعریف کرده اید پیدا نشد. لطفا تیک تماس کارشناس را بزنید تا کارشناسان ما برای انتخاب خودرو با شما هماهنگ کنند و یا نوع خودروی بزرگتری را انتخاب کنید.'});
                    }
                    else {
                        this.setState({car_message : null});
                    }
                    document.getElementById("car-end").scrollIntoView();
                })
                .catch((error) => {
                    toast.error(error.response.data.user_message);
                });
        }
        else {
            this.setState({car_types : []})
        }

    }
    changeLoadingAddressOrder  = (index) => {
        let arr = this.state.loading_addresses;
        arr.splice(index, 0, arr.splice(index - 1, 1)[0]);
        this.setState({loading_addresses : arr})
    }
    changeUnloadingAddressOrder  = (index) => {
        let arr = this.state.unloading_addresses;
        arr.splice(index, 0, arr.splice(index - 1, 1)[0]);
        this.setState({unloading_addresses : arr})
    }
    onDocChange = (event) => {
        this.setState({
            document_file: event.target.files[0]
        })
    }
    changeLoadingDate = (value) => {
        this.setState({'loading_date' : value, 'unloading_date' : '',unloading_time : '00:00' })
        if(moment().toDate().getDate() !== value.toDate().getDate()) {
            this.setState({time_message : '' })
        }
        else {

            if(this.state.loading_time.split(':')[0] <= moment().format('HH')) {
                this.setState({
                    time_message : ' محموله آماده بارگیری می باشد '
                })

            }
        }

    }
    render() {
        let is_verified = 1;
        if(this.state.user_is_verified &&  this.state.company_is_verified) {
            is_verified = 1;
        }
        else {
            is_verified = 0;
        }
        return (
            <React.Fragment>
                {this.state.show_consignments_box &&
                    <div className="add-consignments rtl">

                        <section className='container w-75'>
                            <div className="row  px-5">

                                <h4 className="col-12 text-center my-3 pt-4">
                                    <FontAwesomeIcon icon={faWindowClose} className='close-cong' onClick={() => this.setState({show_consignments_box : false})} />
                                    افزودن محموله جدید
                                </h4>
                                <div className="form-floating small col-md-4 mt-4">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="ctitle" name="ctitle"
                                           placeholder="عنوان"
                                           value={this.state.ctitle}
                                           onChange={this.onInputChange}/>
                                    <label htmlFor="ctitle" className="super-small">عنوان</label>
                                </div>

                                <div className="form-floating small col-8 mt-4">

                                        <textarea className="form-control"
                                                  placeholder="توضیحات"
                                                  id="cdescription"
                                                  name="cdescription"
                                                  value={this.state.cdescription}
                                                  onChange={this.onInputChange}
                                        />

                                    <label htmlFor="cdescription" className="super-small">توضیحات</label>
                                </div>
                                {/*<div className="form-floating  small col-md-4 mt-4">
                                <select className="form-select super-small" id="pack_type" name="pack_type"
                                        aria-label="Floating label select example"
                                        value={this.state.pack_type}
                                        onChange={this.onInputChange}>
                                    <option value={0}>
                                        انتخاب نوع بسته بندی محموله
                                    </option>
                                    {this.state.package_types.map(pack => {
                                        return (
                                            <option value={pack.id} key={pack.id}>
                                                {pack.title} : {pack.description}
                                            </option>
                                        )
                                    })}
                                </select>
                                <label htmlFor="pack_type" className="super-small">نوع بسته بندی</label>
                            </div>*/}
                                <div className=" col-md-8 mt-4 pt-5 text-left">
                                    <button className='btn btn-success  w-50' onClick={this.onSaveConsignment}>
                                        ثبت محموله
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                }
                {/*                <section className='confirm-request' >
                    <article className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    تایید ثبت درخواست
                                </h2>

                            </div>
                        </div>
                    </article>
                </section>*/}
                <Toast/>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>
                            <div className="text-center my-5 text-secondary ">
                                <h2>
                                    <strong>ثبت درخواست بار خرد جدید</strong>
                                </h2>

                            </div>
                            <p className='alert alert-primary text-center small'>
                                در صورتی که بار شما نمی تواند یک خودرو را کامل پر کند درخواست خود را از این قسمت ثبت کند تا کارشناسان ما بار شما را همراه دیگر بارها ارسال کنند.
                                <b>
                                    بارهای خرد ظرف ۴۸ الی ۷۲ ساعت ارسال می گردند
                                </b>
                            </p>
                            {
                                is_verified < 1 ?
                                    <div className="alert alert-danger m-3 small text-center">
                                        حساب کاربری شما هنوز تایید نشده است و نمی توانید درخواستی در سامانه ثبت کنید،
                                        <div>
                                            برای تایید حساب کاربری مشخصات خود را  کامل کرده و منتظر تایید مدیر سامانه بمانید.
                                        </div>

                                    </div>
                                    : ''}
                            {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link  active" id="home-tab" data-toggle="tab" href="#home"
                                       role="tab" aria-controls="home" aria-selected="true">
                                        بارگیری</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " id="profile-tab" data-toggle="tab"
                                       href="#profile"
                                       role="tab" aria-controls="profile" aria-selected="false">
                                        بار</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " id="contact-tab" data-toggle="tab"
                                       href="#contact"
                                       role="tab" aria-controls="contact" aria-selected="false">تنظیمات </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " id="contact-tab" data-toggle="tab"
                                       href="#files"
                                       role="tab" aria-controls="files" aria-selected="false">الحاق فایل</a>
                                </li>

                            </ul>*/}
                            <div className='save-request px-2'>
                                {
                                    is_verified === 1 ?
                                        <button className='btn btn-success new-request-button' id='new-request' onClick={this.onSaveRequest}
                                                disabled={this.state.buttonStatus}
                                        >
                                            <FontAwesomeIcon icon={faCheck} className='mx-2'/>
                                            {this.state.buttonText}
                                            <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                                   aria-hidden="true"></span>
                                        </button> : ''
                                }
                            </div>
                            <div className="" id="myTabContent">
                                <div className="tab-pane fade show active " id="home" role="tabpanel"
                                     aria-labelledby="home-tab">
                                    <section className="container  rtl   px-4 usual-content py-2 ">
                                        <div className="row">
                                            <div className="col-12 new-request-part-title" id='loading-info'>
                                                <FontAwesomeIcon icon={faTruckLoading}/>
                                                &nbsp;
                                                اطلاعات بارگیری
                                            </div>
                                            <div className="col-md-12">
                                                <div className="card border-0">

                                                    <div className="card-body ">
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <select className="form-select super-small" id="loading_addresses" name="loading_addresses"
                                                                        aria-label="Floating label select example"
                                                                        value={0}
                                                                        onChange={this.onLoadingAddressChange}>
                                                                    <option value="0">
                                                                        انتخاب آدرس های بارگیری
                                                                    </option>
                                                                    {this.state.addresses.map(address => {

                                                                        return (
                                                                            address.is_active === 1 ?
                                                                                <option value={address.id} key={address.id}>
                                                                                    {address.title} : {address.address.substring(0, 60)}
                                                                                </option> : ''
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-3">

                                                                <button className='btn btn-outline-primary mobile-button ' onClick={() => this.addNewAddress(73)}>
                                                                    <FontAwesomeIcon icon={faPlus} className='mx-2' />
                                                                    افزودن آدرس جدید
                                                                </button>

                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className=" small border-0 p-4 mt-1 mb-2">
                                                        <div className='small text-success'>
                                                            آدرس های بارگیری انتخابی به ترتیب اولویت بارگیری:
                                                        </div>
                                                        {
                                                            this.state.loading_addresses.map((addr , index) =>{
                                                                return (
                                                                    <div key={addr} className='alert custom-border-bottom'>
                                                                        <FontAwesomeIcon icon={faMapMarkerAlt}
                                                                                         className='text-success mx-3'
                                                                        />
                                                                        <span className='fw-bold text-success px-2 text-right'>
                                                                            {index + 1}  - &nbsp;
                                                                        </span>

                                                                        {this.showLoadingAddress(addr)}
                                                                        <FontAwesomeIcon icon={faWindowClose} className='mx-2  text-danger pointer float-left' title="حذف آدرس از لیست" onClick = {() =>this.removeLoadingAddress(addr)} />
                                                                        {index > 0 &&
                                                                            <FontAwesomeIcon onClick = {() => this.changeLoadingAddressOrder(index)} icon={faArrowAltCircleUp} className='text-primary float-left pointer' title="  بالابردن در لیست" /> }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </section>
                                    <section className="container  rtl   px-4 usual-content py-2 mt-2 ">
                                        <div className="row">
                                            <div className="col-12 new-request-part-title" id='unloading-info'>
                                                <FontAwesomeIcon icon={faCloudDownloadAlt}/>
                                                &nbsp;
                                                اطلاعات تخلیه
                                            </div>
                                            <div className="col-md-12">
                                                <div className="card border-0">
                                                    <div className="card-body ">
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <select className="form-select super-small" id="loading_addresses" name="loading_addresses"
                                                                        aria-label="Floating label select example"
                                                                        value={0}
                                                                        onChange={this.onUnloadingAddressChange}>
                                                                    <option value="0">
                                                                        انتخاب آدرس های تخلیه
                                                                    </option>
                                                                    {this.state.addresses.map(address => {
                                                                        return (
                                                                            address.is_active === 1 ?
                                                                                <option value={address.id} key={address.id}>
                                                                                    {address.title} : {address.address.substring(0, 60)}
                                                                                </option> : ''
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className='btn btn-outline-primary mobile-button' onClick={() => this.addNewAddress(72)}>
                                                                    <FontAwesomeIcon icon={faPlus} className='mx-2' />
                                                                    افزودن آدرس جدید
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="rounded  small border-0 p-4 my-2">
                                                        <div className='small text-danger'>
                                                            آدرس های تخلیه انتخابی به ترتیب اولویت بارگیری:
                                                        </div>
                                                        {
                                                            this.state.unloading_addresses.map((addr , index) =>{
                                                                return (
                                                                    <div key={addr} className='alert custom-border-bottom'>
                                                                        <FontAwesomeIcon icon={faMapMarkerAlt}
                                                                                         className='text-danger mx-3'
                                                                        />
                                                                        <span className='fw-bold text-danger px-2 text-right'>
                                                                            {index + 1}  - &nbsp;
                                                                        </span>

                                                                        {this.showUnloadingAddress(addr)}
                                                                        <FontAwesomeIcon icon={faWindowClose} className='mx-2  text-danger pointer float-left' title="حذف آدرس از لیست" onClick = {() =>this.removeUnloadingAddress(addr)} />
                                                                        {index > 0 &&
                                                                            <FontAwesomeIcon onClick = {() => this.changeUnloadingAddressOrder(index)} icon={faArrowAltCircleUp} className='text-primary float-left pointer' title="  بالابردن در لیست" /> }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*  <div className="row">
                                            <div className="  form-floating col-md-6 mt-4">

                                                <DatePicker
                                                    calendarStyles={styles}
                                                    inputFormat="jYYYY/jM/jD"
                                                    className="form-control border-0 pdate-picker px-5 text-left"
                                                    min={moment(this.state.loading_date).subtract(1 , 'days')}
                                                    max={moment(this.state.loading_date).add(2 , 'days')}
                                                    value={this.state.unloading_date}
                                                    onChange={(value)=> this.setState({'unloading_date' : value})}
                                                />
                                                <label htmlFor="unloading_date" className="super-small" id='unloading-date-label'>تاریخ تخلیه</label>
                                            </div>
                                            <div className=" form-floating col-md-6 mt-4">
                                                <TimePicker
                                                    timeMode="24"
                                                    withoutIcon
                                                    time={this.state.unloading_time}
                                                    timeFormat='HH:MM'
                                                    onTimeChange={(event) => this.onTimeChange (event , 'unloading_time')}

                                                />
                                                <label htmlFor="unloading_time" className="super-small">ساعت تخلیه</label>
                                                <span className='float-left super-small-2'>
                                                     <input type="checkbox"
                                                            className="custom-control-input"
                                                            placeholder=""
                                                            value="1"
                                                            onChange={() => {this.setState({'show_do_unloading' : 1 - this.state.show_do_unloading })}}/>
                                                    &nbsp;
                                                    <label className="custom-control-label text-secondary">
                                                   دارای محدودیت زمانی
                                                </label>
                                                </span>
                                            </div>
                                            {
                                                this.state.show_do_unloading > 0 ?
                                                    <React.Fragment>
                                            <div className=" form-floating col-md-6 mt-4">
                                                <TimePicker
                                                    timeMode="24"
                                                    withoutIcon
                                                    time={this.state.unloading_do_from}
                                                    timeFormat='HH:MM'
                                                    onTimeChange={(event) => this.onTimeChange (event , 'unloading_do_from')}
                                                    disabled =  {1}

                                                />
                                                <label htmlFor="loading_do_from" className="super-small">شروع محدودیت تخلیه</label>
                                            </div>
                                            <div className=" form-floating col-md-6 mt-4">
                                                <TimePicker
                                                    timeMode="24"
                                                    withoutIcon
                                                    time={this.state.unloading_do_to}
                                                    timeFormat='HH:MM'
                                                    onTimeChange={(event) => this.onTimeChange (event , 'unloading_do_to')}

                                                />
                                                <label htmlFor="loading_do_to" className="super-small">پایان محدودیت تخلیه</label>
                                            </div>
                                                    </React.Fragment>
                                                    : '' }
                                        </div>*/}
                                    </section>
                                    <section className="container rtl px-4 usual-content py-2 mt-2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card border-0">
                                                    <div className="card-body ">
                                                        <div className="row">

                                                            <div className="col-12 new-request-part-title" id='load-info'>
                                                                <FontAwesomeIcon icon={faCubes}/>
                                                                &nbsp;
                                                                اطلاعات بار
                                                            </div>
                                                            <div className="col-md-9">
                                                                <select className="form-select super-small" id="loading_addresses" name="loading_addresses"
                                                                        aria-label="Floating label select example"
                                                                        value={0}
                                                                        onChange={this.onConsignmentsListChange}>
                                                                    <option value="0">
                                                                        انتخاب محموله
                                                                    </option>
                                                                    {this.state.consignments_list.map(cong => {
                                                                        return (
                                                                            <option value={cong.id} key={cong.id}>
                                                                                {cong.title} : {cong.description}
                                                                            </option>
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-3">

                                                                <button className='btn btn-outline-primary float-left mobile-button' onClick={() => this.setState({show_consignments_box : true})}>
                                                                    <FontAwesomeIcon icon={faPlus} className='mx-2' />
                                                                    افزودن محموله جدید
                                                                </button>

                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="rounded  small border-0 p-4 my-2">
                                                        {
                                                            this.state.consignments.map((cong , index) =>{
                                                                return (
                                                                    <div key={cong} className='alert custom-border-bottom'>



                                                                        {this.showConsignmentsList(cong)}
                                                                        <FontAwesomeIcon icon={faWindowClose} className='mx-2  text-danger pointer float-left' title="حذف محموله از لیست" onClick = {() =>this.removeConsignmentsList(cong)} />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </section>

                                    <section className="container  rtl   px-4 usual-content py-2 mt-2">
                                        <div className="row">
                                            <div className="col-12 new-request-part-title" id='setting-info'>
                                                <FontAwesomeIcon icon={faServer}/>
                                                &nbsp;
                                                تنظیمات
                                            </div>
                                            <div className="form-floating col-md-12 mt-4">
                                    <textarea
                                        className="form-control px-5"
                                        id="description" name="description"
                                        placeholder=" توضیحات"
                                        value={this.state.description}
                                        onChange={this.onInputChange}/>
                                                <label htmlFor="address" className="super-small"> توضیحات</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="pack_count" name="pack_count"
                                                       placeholder="تعداد بسته"
                                                       value={this.state.pack_count}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="pack_count" className="super-small">تعداد بسته</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_value" name="load_value"
                                                       placeholder="ارزش بار"
                                                       value={this.state.load_value}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="load_value" className="super-small">ارزش بار (ریال)</label>
                                                <p className='small text-center pt-2 fw-bold'>
                                                    {this.state.load_value  && currencyFormat.format(this.state.load_value / 10)}

                                                    {this.state.load_value &&
                                                        <span className='super-small fw-normal px-2'>
                                                        تومان
                                                    </span>
                                                    }
                                                </p>
                                            </div>
                                            <div className="col-12">

                                                <div className="alert alert-secondary text-center small">
                                                   ابعاد و وزن بار خود را با دقت وارد کنید
                                                </div>
                                            </div>
                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_width1" name="load_width1"
                                                       placeholder="عرض"
                                                       value={this.state.load_width1}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_width1" className="super-small">عرض (متر)</label>
                                                <p className="super-small py-2 text-info">
                                                    به عنوان مثال ۲ متر و ۱۵ سانتی متر
                                                </p>
                                            </div>
                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_width2" name="load_width2"
                                                       placeholder="عرض بار"
                                                       value={this.state.load_width2}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_width2" className="super-small">عرض (سانتی متر)</label>
                                            </div>
                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_height1" name="load_height1"
                                                       placeholder="ارتفاع"
                                                       value={this.state.load_height1}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_height1" className="super-small">ارتفاع (متر)</label>
                                                <p className="super-small py-2 text-info">
                                                    به عنوان مثال ۱ متر و ۸۰ سانتی متر
                                                </p>
                                            </div>
                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_height2" name="load_height2"
                                                       placeholder="ارتفاع بار"
                                                       value={this.state.load_height2}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_height2" className="super-small">ارتفاع (سانتی متر)</label>

                                            </div>

                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_length1" name="load_length1"
                                                       placeholder="طول"
                                                       value={this.state.load_length1}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_length1" className="super-small">طول (متر)</label>
                                                <p className="super-small py-2 text-info">
                                                    به عنوان مثال ۱ متر و ۲۰ سانتی متر
                                                </p>
                                            </div>
                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_length2" name="load_length2"
                                                       placeholder="طول بار"
                                                       value={this.state.load_length2}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_length2" className="super-small">طول (سانتی متر)</label>
                                            </div>

                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_tonnage1" name="load_tonnage1"
                                                       placeholder="وزن"
                                                       value={this.state.load_tonnage1}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_tonnage1" className="super-small">وزن (تن)</label>
                                                <p className="super-small py-2 text-info">
                                                    به عنوان مثال ۲ تن و ۳۰۰ کیلوگرم
                                                </p>
                                            </div>
                                            <div className="form-floating col-md-3 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="load_tonnage2" name="load_tonnage2"
                                                       placeholder="وزن بار"
                                                       value={this.state.load_tonnage2}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="load_tonnage2" className="super-small">وزن (کیلو
                                                    گرم)</label>
                                            </div>
                                        </div>
                                    </section>
                                    {/* <section className="container  rtl   px-4 usual-content py-2 mt-2">
                                        <div className="row">
                                            <div className="col-12 new-request-part-title" id='setting-info'>
                                                <FontAwesomeIcon icon={faServer}/>
                                                &nbsp;
                                               تنظیمات
                                            </div>
                                            <div className="form-floating col-md-12 mt-4">
                                    <textarea
                                        className="form-control px-5"
                                        id="description" name="description"
                                        placeholder=" توضیحات"
                                        value={this.state.description}
                                        onChange={this.onInputChange}/>
                                                <label htmlFor="address" className="super-small"> توضیحات</label>
                                            </div>

                                            <div className="custom-control custom-checkbox col-md-6 mt-4">

                                                <input type="checkbox"
                                                       className="custom-control-input" id="pay_type_check" name="pay_type_check"
                                                       placeholder=""
                                                       value="1"
                                                       onChange={this.onInputChange}/>
                                                &nbsp;
                                                <label htmlFor="pay_type_check"  className="custom-control-label ">
                                                    پرداخت کرایه به صورت پس از رسید
                                                </label>
                                                <p className="super-small-2 text-secondary rtl text-justify">
                                                    در صورتی که کرایه را در مقصد پرداخت می کنید این گزینه را انتخاب نکنید.
                                                </p>
                                            </div>
                                            <div className="custom-control custom-checkbox col-md-6 mt-4">

                                                <input type="checkbox"
                                                       className="custom-control-input" id="need_delivery_documents" name="need_delivery_documents"
                                                       placeholder=""
                                                       value="1"
                                                       onChange={this.onInputChange}/>
                                                &nbsp;
                                                <label htmlFor="need_delivery_documents"  className="custom-control-label ">نیاز به اسناد تحویل</label>
                                                <p className="super-small-2 text-secondary rtl text-justify">
                                                    در صورتی که پس از تخلیه بار اسناد تحویل را نیاز دارید این گزینه را انتخاب کنید.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="custom-control custom-checkbox col-md-6 mt-4">

                                                <input type="checkbox"
                                                       className="custom-control-input" id="need_expert" name="need_expert"
                                                       placeholder=""
                                                       value="1"
                                                       onChange={this.onInputChange}/>
                                                &nbsp;
                                                <label htmlFor="need_expert"  className="custom-control-label ">درخواست تماس کارشناس برای انتخاب خودرو</label>
                                                <p className="super-small-2 text-secondary rtl text-justify">
                                                    در صورتی که از نوع خودروی انتخابی مطمئن نیستید و برای انتخاب صحیح نیازمند مشاوره کارشناسان هستید این گزینه را انتخاب کنید.
                                                    <b>کارشناسان ما با شما تماس می گیرند</b>
                                                </p>
                                            </div>
                                            <div className="custom-control custom-checkbox col-md-6 mt-4">

                                                <input type="checkbox"
                                                       className="custom-control-input" id="is_personal" name="is_personal"
                                                       placeholder=""
                                                       value="1"
                                                       onChange={this.onInputChange}/>
                                                &nbsp;
                                                <label htmlFor="is_personal"  className="custom-control-label text-primary"> ثبت درخواست به صورت شخصی</label>
                                                <p className="super-small-2 text-secondary rtl text-justify">
                                                    در صورتی که درخواست به صورت شخصی ثبت شود توسط دیگر همکارانتان در شرکت قابل ملاحظه نمی باشد و فقط برای شما  ثبت می شود
                                                </p>
                                            </div>

                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="number"
                                                       className="form-control px-5"
                                                       id="suggested_price" name="suggested_price"
                                                       placeholder="نرخ "
                                                       value={this.state.suggested_price}
                                                       onChange={this.onInputChange}/>

                                                <label htmlFor="suggested_price" className="super-small">نرخ پیشنهادی (ریال
                                                    )</label>
                                                <p className='small text-center pt-2 fw-bold'>
                                                    {this.state.suggested_price  && currencyFormat.format(this.state.suggested_price / 10)}

                                                    {this.state.suggested_price &&
                                                        <span className='super-small fw-normal px-2'>
                                                        تومان
                                                    </span>
                                                    }
                                                </p>
                                            </div>

                                        </div>

                                    </section>*/}

                                </div>
                                {/* <div className="tab-pane fade  " id="profile" role="tabpanel"
                                     aria-labelledby="profile-tab">

                                </div>

                                <div className="tab-pane fade  " id="contact" role="tabpanel"
                                     aria-labelledby="contact-tab">

                                </div>
                                <div className="tab-pane fade  " id="files" role="tabpanel"
                                     aria-labelledby="files-tab">

                                </div>*/}
                            </div>




                        </div>

                    </div>
                </section>
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        API.getAddresses()
            .then((response) => {
                const addresses = response.results.addresses;
                this.setState({addresses})
                addresses.forEach( (item, index) =>{
                    if(item.type === 73 && item.is_default === 1 && item.is_active !== 0) {
                        this.setState({loading_addresses : [item.id]})
                    }
                    if(item.type === 72 && item.is_default === 1 && item.is_active !== 0) {
                        this.setState({unloading_addresses : [item.id]})
                    }
                })

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        API.consignments()
            .then((response) => {

                const consignments_list = response.results.consignments;
                this.setState({consignments_list})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        API.packageTypes()
            .then((response) => {

                const package_types = response.results.package_types;
                this.setState({package_types})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        const request = {
            min_tonnage: -1,
            min_length: -1,
            min_width: -1,
            min_height: -1
        }
        API.carTypes(request)
            .then((response) => {
                const parent_car_types = response.results.car_types;

                this.setState({parent_car_types})
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        API.profile()
            .then((response) => {
                const user_is_verified = response.results.user.user_groups_global[0].is_verified;
                this.setState({user_is_verified});
            })
        API.getCompany()
            .then((response) => {
                const company_is_verified = response.results.company.is_verified;
                this.setState({company_is_verified})

            })
        window.localStorage.removeItem("return_to");
        const d = new Date();

        this.setState({
            loading_date : moment(),
            unloading_date : moment().add(2,'days'),
            loading_time:d.getHours()  + ":" + d.getMinutes(),

        })
    }
}

export default NewSmallCargoRequest;